import React from 'react';
import { observer } from 'mobx-react-lite';

import { FightersCashOutHeader } from '../../../components/fightersCashOutHeader';
import { FightersStandardHeader } from '../../../components/fightersStandardHeader';

export const BetSectionHeader = observer(
  ({
    t,
    betData,
    oddData,
    haveDoBet,
    isRoundFin,
    isBetsClosed,
    isNotHaveActiveBets,
    currentFighterSection,
    setActiveCurrentSection,
  }) => {
    return (
      // ADD CLASS " tab-states "
      <div
        className={`bet-top-row ${
          isBetsClosed && haveDoBet && oddData && !isNotHaveActiveBets ? 'tab-states' : ''
        }`}
      >
        <FightersStandardHeader
          t={t}
          betData={betData}
          currentFighterSection={currentFighterSection}
          setActiveCurrentSection={setActiveCurrentSection}
        />
        <FightersCashOutHeader
          t={t}
          betData={betData}
          oddData={oddData}
          isRoundFin={isRoundFin}
          isBetsClosed={isBetsClosed}
          currentFighterSection={currentFighterSection}
        />
      </div>
    );
  }
);
